import {
  getEmoji,
  getInLink,
  getOutLink,
  getTime
} from 'components/navbar/top/NotificationDropdown';
import Notification from 'components/notification/Notification';
import { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNotifications,
  markAllAsRead,
  markAsRead
} from 'redux/notificationsSlice';

const Notifications = () => {
  const dispatch = useDispatch();

  const userLogged = useSelector(state => state.login.currentUser);
  const { notifications } = useSelector(state => state.notifications);

  useEffect(() => {
    userLogged && dispatch(getNotifications(userLogged.id));
  }, [userLogged]);

  const handleClick = async notification => {
    await dispatch(markAsRead(notification.id));
    await dispatch(getNotifications(userLogged.id));
  };

  const markAllNotisAsRead = async () => {
    await dispatch(markAllAsRead(userLogged.id));
    await dispatch(getNotifications(userLogged.id));
  };

  return (
    <Card>
      <Card.Header className="bg-light">
        <Row className="flex-between-center">
          <Col sm="auto">
            <h5 className="mb-1 mb-md-0">Sus Notificaciones</h5>
          </Col>
          <Col sm="auto" className="fs--1">
            <div
              onClick={markAllNotisAsRead}
              className="font-sans-serif ms-2 ms-sm-3 link-primary cursor-pointer"
            >
              Marcar como leídas
            </div>
            <div className="font-sans-serif ms-2 ms-sm-3"></div>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="p-0">
        {notifications
          .map(n => ({
            id: n.id,
            children: `<strong>${n.title}</strong>: ${n.body}`,
            time: getTime(n.created_at),
            emoji: getEmoji(n.info.type),
            className: 'rounded-0 border-x-0 border-300 border-bottom-0',
            unread: !n.read,
            info: n.info,
            type: n.info.type,
            outLink: getOutLink(n.info),
            inLink: getInLink(n.info)
          }))
          .map(notification => (
            <div
              key={notification.id}
              onClick={() => handleClick(notification)}
            >
              <Notification {...notification} />
            </div>
          ))}
      </Card.Body>
    </Card>
  );
};

export default Notifications;
